import { render, staticRenderFns } from "./PorReincidencia.vue?vue&type=template&id=50b6cc74&scoped=true&lang=pug&"
import script from "./PorReincidencia.vue?vue&type=script&lang=js&"
export * from "./PorReincidencia.vue?vue&type=script&lang=js&"
import style0 from "./PorReincidencia.vue?vue&type=style&index=0&id=50b6cc74&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b6cc74",
  null
  
)

export default component.exports